import React, { useContext, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import client from "../api/client";
import CircularProgress from "../components/Generic/CircularProgress";
import { GlobalContext } from "../context";
import MainLayouts from "../layout/MainLayouts";

export default function JanuaryWaitList() {
  const { state } = useLocation();
  const preSelectedCourse = state?.course ?? null;

  const {
    countryCodeState: { data },
    onlineCoursesState,
    liveCoursesState,
  } = useContext(GlobalContext);

  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    email: "",
    first_name: "",
    last_name: "",
    phone: "",
    location: "",
    country_code: "",
    course_uuid: preSelectedCourse?.uuid || "",
    how_did_you_know_about_us: "",
  });

  const [loading, setLoading] = useState(false);

  const allCourses = [
    ...(Array.isArray(onlineCoursesState?.data) ? onlineCoursesState.data : []),
    ...(Array.isArray(liveCoursesState?.data) ? liveCoursesState.data : []),
  ];

  const selectedCourseTitle =
    preSelectedCourse?.title ||
    allCourses.find((c) => c.uuid === formData.course_uuid)?.title ||
    null;

  const heading = selectedCourseTitle
    ? `Join Waitlist — ${selectedCourseTitle}`
    : "Join the Waitlist";

  const handleChange = (field) => (e) =>
    setFormData((prev) => ({ ...prev, [field]: e.target.value }));

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    try {
      await client.post("/waitlist", formData);
      setFormData({
        email: "",
        first_name: "",
        last_name: "",
        phone: "",
        location: "",
        country_code: "",
        course_uuid: preSelectedCourse?.uuid || "",
        how_did_you_know_about_us: "",
      });
      toast.success("You've been added to the waitlist!");
      setTimeout(() => navigate("/"), 3000);
    } catch (error) {
      toast.error(
        error?.response?.data?.message || error.message || "An error occurred"
      );
    }
    setLoading(false);
  };

  return (
    <MainLayouts>
      <div className="innersection">
        <div className="w-full sm:w-1/2 mx-auto mb-[25vh] mt-[25vh] bg-[#f7f7f7] rounded-xl">
          <form
            onSubmit={handleSubmit}
            className="px-[4%] md:px-[10%] py-[6%] mx-auto rounded"
          >
            <h2 className="text-2xl font-bold text-center mb-[5%]">
              {heading}
            </h2>

            {!preSelectedCourse && (
              <div className="mb-[5%]">
                <select
                  value={formData.course_uuid}
                  onChange={handleChange("course_uuid")}
                  className="w-full border-solid border-[1px] border-[#eee] py-2 px-5 rounded text-sm bg-white"
                >
                  <option value="">— Select a course (optional) —</option>
                  {allCourses.map((c) => (
                    <option key={c.uuid} value={c.uuid}>
                      {c.title}
                    </option>
                  ))}
                </select>
              </div>
            )}

            {preSelectedCourse && (
              <div className="mb-[5%] text-center text-sm text-gray-500">
                We'll notify you as soon as a cohort opens for this course.
              </div>
            )}

            <div className="flex justify-between gap-2 mb-[5%]">
              <input
                type="text"
                placeholder="First Name"
                value={formData.first_name}
                onChange={handleChange("first_name")}
                required
                className="inline-block border-solid border-[1px] border-[#eee] py-2 px-5 rounded w-[48%] placeholder:text-xs text-sm"
              />
              <input
                type="text"
                placeholder="Last Name"
                value={formData.last_name}
                onChange={handleChange("last_name")}
                required
                className="inline-block border-solid border-[1px] border-[#eee] py-2 px-5 rounded w-[48%] placeholder:text-xs text-sm"
              />
            </div>

            <div className="mb-[5%]">
              <input
                type="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleChange("email")}
                required
                className="w-full border-solid border-[1px] border-[#eee] py-2 px-5 rounded placeholder:text-xs text-sm"
              />
            </div>

            <div className="flex items-center gap-2 mb-[5%]">
              <select
                value={formData.country_code}
                onChange={handleChange("country_code")}
                className="w-1/4 border-solid border-[1px] border-[#eee] py-2 px-2 rounded text-sm bg-white"
              >
                <option value="">+</option>
                {data?.length > 0 &&
                  data.map((cur, i) => (
                    <option key={i} value={cur.code}>
                      {cur.code} {cur.name}
                    </option>
                  ))}
              </select>
              <input
                type="text"
                placeholder="Phone Number"
                value={formData.phone}
                onChange={handleChange("phone")}
                required
                className="w-full border-solid border-[1px] border-[#eee] py-2 px-5 rounded placeholder:text-xs text-sm"
              />
            </div>

            <div className="mb-[5%]">
              <input
                type="text"
                placeholder="Location (City, Country)"
                value={formData.location}
                onChange={handleChange("location")}
                required
                className="w-full border-solid border-[1px] border-[#eee] py-2 px-5 rounded placeholder:text-xs text-sm"
              />
            </div>

            <div className="mb-[5%]">
              <select
                value={formData.how_did_you_know_about_us}
                onChange={handleChange("how_did_you_know_about_us")}
                className="w-full border-solid border-[1px] border-[#eee] py-2 px-5 rounded text-sm bg-white"
              >
                <option value="">How did you hear about us? (optional)</option>
                <option value="social_media">Social Media</option>
                <option value="friend">Friend / Family</option>
                <option value="search">Search Engine</option>
                <option value="advertisement">Advertisement</option>
                <option value="other">Other</option>
              </select>
            </div>

            <button
              type="submit"
              className="w-full py-2 px-5 rounded text-sm bg-primary-color hover:bg-[#884c34] delay-0 duration-150 transition-colors ease-in text-white font-medium mt-[5%]"
            >
              {loading ? <CircularProgress /> : "JOIN WAITLIST"}
            </button>
          </form>
        </div>
      </div>
    </MainLayouts>
  );
}
